<div
  [ngClass]="{
    'page-container': true,
    'shui-page-container': style === 'shui',
  }"
>
  <main
    class="page-content"
  >
    <section class="content">
      <ng-content></ng-content>
      <router-outlet></router-outlet>
    </section>
  </main>
</div>
